module.exports = __webpack_public_path__ + "static/media/image34.9a1d32e8.png";